@import (reference) '../../../../../constants/spacing.module.less';

.rate-details {
  justify-content: space-between;
  align-items: center;
  gap: @space-16;
}

.missing-service-selection {
  color: var(--light--text-color--1);
  max-width: 160px;
  flex: 1;
}
